import React from "react";
import { Button, Form } from "react-bootstrap";

import "bootstrap/dist/css/bootstrap.min.css";

const controllerChoices = ["Default", "None", "Custom"];

export default function TableRow(props) {
  function updateParent(id, key, value) {
    props.onToggleComplete(id, key, value);
  }

  return (
    <tbody>
      {props.list.map((item, index) => (
        <tr key={item.id}>
          <td>{index + 1}</td>
          <td>{item.name}</td>
          <td>
            <Form.Check
              type="checkbox"
              checked={item.model} // React checkbox onChange get value
              onChange={(e) => {
                updateParent(item.id, "model", e.target.checked);
                //setAddModel(e.target.checked);
              }} // React checkbox onChange setState
            />
          </td>
          <td>
            <Form.Select
              value={item.controller}
              onChange={(e) => {
                updateParent(item.id, "controller", e.target.value);
                //setAddModel(e.target.checked);
              }}
            >
              {controllerChoices.map((choice, choiceIx) => (
                <option key={choiceIx} value={choice}>
                  {choice}
                </option>
              ))}
            </Form.Select>
          </td>
          <td>
            <Form.Check
              type="checkbox"
              checked={item.seeder} // React checkbox onChange get value
              onChange={(e) => {
                updateParent(item.id, "seeder", e.target.checked);
                //setAddModel(e.target.checked);
              }} // React checkbox onChange setState
            />
          </td>
          {/* <td>
            <Form.Check
              type="checkbox"
              checked={item.migration} // React checkbox onChange get value
              onChange={(e) => {
                updateParent(item.id, "migration", e.target.checked);
                //setAddModel(e.target.checked);
              }} // React checkbox onChange setState
            />
          </td> */}
          <td>
            <Button variant="danger" onClick={() => props.onRemove(item.id)}>
              {"Remove "}
            </Button>
          </td>
        </tr>
      ))}
    </tbody>
  );
}
